import React, { useEffect, useState } from 'react';
import { Condition } from '../../../types/segments/segments.types';
import { TRIGGERS } from './Trigger/triggerConstants';
import SegmentChangeScreen from './Trigger/SegmentChangeScreen';
import EventConfigScreen from './Trigger/EventConfigScreen';
import TriggerCardsGrid from './Trigger/TriggerCardsGrid';

interface TriggerStepProps {
  triggerType?: string;
  event?: string;
  onEventChange: (event: string) => void;
  selectedTrigger: string | null;
  onTriggerSelect: (triggerId: string) => void;
  conditions: { [key: string]: Condition[] };
  setConditions: (conditions: { [key: string]: Condition[] }) => void;
  campaignStatus?: 'draft' | 'live' | 'paused' | 'archived';
}

const TriggerStep: React.FC<TriggerStepProps> = ({
  triggerType,
  event,
  onEventChange,
  selectedTrigger,
  onTriggerSelect,
  conditions,
  setConditions,
  campaignStatus,
}) => {
  const [showConditionBuilder, setShowConditionBuilder] = useState(false);
  const [showEventConfig, setShowEventConfig] = useState(true);

  const effectiveTrigger = selectedTrigger || triggerType || null;

  useEffect(() => {
    if (conditions && Object.keys(conditions).length > 0) {
      setShowConditionBuilder(true);
    }
  }, [conditions]);

  useEffect(() => {
    if (
      triggerType === 'attribute-segment' &&
      conditions &&
      Object.keys(conditions).length > 0
    ) {
      setShowConditionBuilder(true);
    }
  }, [triggerType, conditions]);

  useEffect(() => {
    if (effectiveTrigger === 'event') {
      setShowEventConfig(true);
    }
  }, [effectiveTrigger]);

  const groupedTriggers = { triggers: TRIGGERS };

  const showSegmentScreen =
    effectiveTrigger === 'attribute-segment' && showConditionBuilder;
  const showEventScreen = effectiveTrigger === 'event' && showEventConfig;

  const handleEventBack = () => {
    setShowEventConfig(false);
    onTriggerSelect('');
  };

  return (
    <div className="flex h-[calc(90vh-40px)]">
      <div className="flex-1 overflow-y-auto bg-background">
        <div className="max-w-6xl mx-auto p-6">
          {showSegmentScreen ? (
            <SegmentChangeScreen
              conditions={conditions}
              onConditionsChange={setConditions}
              onBack={() => setShowConditionBuilder(false)}
              campaignStatus={campaignStatus}
            />
          ) : showEventScreen ? (
            <EventConfigScreen
              event={event}
              conditions={conditions}
              onConditionsChange={setConditions}
              onEventChange={onEventChange}
              onBack={handleEventBack}
              campaignStatus={campaignStatus}
              hideBackButton={triggerType !== '' && triggerType !== undefined}
            />
          ) : (
            <TriggerCardsGrid
              groupedTriggers={groupedTriggers}
              onTriggerSelect={onTriggerSelect}
              onSegmentChangeSelect={() => setShowConditionBuilder(true)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TriggerStep;
